module.exports = __webpack_public_path__ + "img/loading-spinner-gray.65850def.svg";